module.exports = __webpack_public_path__ + "img/Menu-12.4614809d.png";